class Extranet.Models.Contact extends Extranet.Model

  idAttribute: 'uuid'
  urlRoot: '/v2/getaways/extranet/contacts'